/* eslint-disable max-len */
/* eslint-disable no-console */
import React from 'react';
import { Box, CardContent, Grid, Typography, useMediaQuery } from '@mui/material';
import ProfilePic from '../../../../components/Common/ProfilePic';
import { RecognisedBackGround } from '../../../Recognition/components/RecognitionBackground';
import { useTheme } from '@mui/material/styles';
import { getDesignElements, planeCard } from './EventCardUtils';

const CommonEventCard = (eachEvent, index) =>
{
	const theme = useTheme();
	const downSM = useMediaQuery(theme.breakpoints.down(1300));

	const msgObj = {
		2 : 'Happy Birthday',
		3 : 'Happy Wedding Anniversary',
		4 : 'Happy Work Anniversary'
	};

	const getBackgroundClass = (templateId) =>
	{
		switch (templateId)
		{
			case 'T2':
				return 'recBg2';
			case 'T3':
				return 'recBg3';
			default:
				return 'recBg1';
		}
	};

	return (
		<>
			{eachEvent?.eachEvent?.eventType === 1
				? (
					<div
						style={{ height: downSM ? '156px' : '180px' }}
						key={index}
						className={`flexRow brdrRadiusSM brdrBlackSM eventCardHeight ${getBackgroundClass(
							eachEvent?.eachEvent?.templateId
						)}`}
					>
						<div className='flexCol pdngTMD'>
							<div className='flexRow pdngHXS'>
								<div className='flexAutoRow positionRelative'>
									<div className='newsRecbadgeImg positionRelative'>
										<img
											src={RecognisedBackGround(
												'rectangle',
												eachEvent?.eachEvent?.templateId,
												eachEvent?.eachEvent?.badgeId
											)?.badge}
											alt='badgeimg'
										/>
										<div className='newsrecAvtharImg'>
											<ProfilePic
												imagePath={`${eachEvent?.eachEvent?.employeeId}.jpeg?t=${new Date().valueOf()}`}
												defaultImg='/images/icons/defaultUser.svg'
												alt='profile'
												className='brdrRadius50'
												from='selfProfile'
											/>
										</div>
									</div>
								</div>
								<div className='flexMinWidthCol pdngVSM' style={{ paddingLeft: '12px' }} >
									<div className='flexRow'>
										<h3 className='recDarktGold recognizCardHeadding ellipsisTxt firstLetter mrgnBXXS'>
											{eachEvent?.eachEvent?.title || ''}
										</h3>
									</div>
									<div className='flexRow'>
										<span className='recDarktGold capitalTxt recognizCardSubHeadding ellipseLen2'>
											{eachEvent?.eachEvent?.employeeData?.name || ''}
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				)
				: (
					<Grid item xs={12} key={index}>
						<Box
							alignItems='center'
							display='flex'
							sx={{
								borderRadius : 'var(--pixel8)',
								cursor       : 'pointer',
								width        : 'var(--percent100)',
								position     : 'relative',
								background   : planeCard.find((item) => item?.eventType === eachEvent?.eachEvent?.eventType)?.src || planeCard[0]?.src,
								height       : downSM ? '156px' : '180px' // Card height
							}}
						>
							{/* Balloons and Cake */}
							{getDesignElements(eachEvent?.eachEvent?.eventType, 'defaultE', false).map((item, idx) => (
								<Box
									key={idx}
									component='img'
									src={item?.src}
									sx={{
										position : 'absolute',
										top      : item?.top || 'auto',
										bottom   : item?.bottom || 'auto',
										left     : item?.left || 'auto',
										right    : item?.right || 'auto',
										width    : `${item?.width} !important`,
										height   : `${item?.height}!important`,
										'& img'  : {
											width        : 'var(--percent100)',
											height       : 'var(--percent100)',
											objectFit    : 'cover',
											borderRadius : 'var(--pixel8)'
										}
									}}
								/>
							))}

							<CardContent
								sx={{
									display        : 'flex',
									flexDirection  : 'column',
									justifyContent : 'space-between',
									height         : 'var(--percent100)',
									position       : 'relative',
									// zIndex         : 1,
									// maxWidth       : '300px',
									color          : 'var(--whiteColor)'
								}}
							>
								<Typography variant='h6' component='div'
									sx={{
										mb              : 2,
										fontWeight      : 'bold',
										overflow        : 'hidden',
										display         : '-webkit-box',
										WebkitLineClamp : 2,
										WebkitBoxOrient : 'vertical'
									}}
								>
									{msgObj[eachEvent?.eachEvent?.eventType]}
								</Typography>
								<Box display='flex' flexDirection='row' alignItems='center'>
									<div className='flexInline imgAvatarNewsSM brdrRadius50 whiteBrdr'>
										<ProfilePic
											imagePath={`${eachEvent?.eachEvent?.employeeId}.jpeg?t=${new Date().valueOf()}`}
											defaultImg='/images/icons/defaultUser.svg'
											alt='profile'
											className='brdrRadius50'
											from='selfProfile'
										/>
									</div>
									<Typography
										variant='body2'
										sx={{ flexGrow: 1, wordbreak: 'break-all' }}
										pl='var(--pixel8)'
										color='var(--whiteColor)'
									>
										Hello {eachEvent?.eachEvent?.employeeData?.name} {eachEvent?.eachEvent?.title}
									</Typography>

								</Box>
							</CardContent>
						</Box>
					</Grid>
				)}
		</>
	);
};

export default CommonEventCard;
